import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getEmployeeArriveLateDetailStart,
  getEmployeeArriveLateDetailSuccess,
  getEmployeeArriveLateDetailFailed,
} from "../redux/getEmployeeArriveLateDetail";
import {
  formReqArrivingLateLeaveEarlyUpdate,
  formReqLongTermUpdate,
  TypeSelect,
} from "../redux/formReqArrivingLateLeaveEarly";
import moment from "moment";
import { toast } from "react-toastify";
import { ErrorMessage } from "core/http/service/decleareLeave/const";
import { getEmployeeArriveLateDetailApi } from "core/http/service/employeeRequest";

function* getEmployeeArriveLateDetailWork(action) {
  const { id } = action.payload;
  try {
    const res = yield call(getEmployeeArriveLateDetailApi, id);
    const payloadForm = {
      type: res?.type,
      relatedPersonCodes:
        res?.relatedPersons?.map((it) => ({
          label: `${it?.label} - ${it?.positionName}`,
          value: it?.value || it?.employeeCode,
        })) || [],
      note: res?.note,
      approveCode: res?.approveCode,
      approveName: res?.approveName,
    };
    const formLongTerm =
      res?.type === TypeSelect.SHORT_TERM
        ? {}
        : {
            fromDate: moment(res?.details[0]!?.fromDate),
            toDate: moment(res?.details[res?.details?.length - 1]!?.toDate),
            time: res?.details[0]!?.minuteAmount
              ? res?.details[0]!?.minuteAmount?.toString()
              : "",
            typeReq: res?.details[0]!?.type,
            reason: res?.details[0]!?.reasonCode || "",
          };

    yield put({
      type: getEmployeeArriveLateDetailSuccess.type,
      payload: res,
    });

    yield put({
      type: formReqArrivingLateLeaveEarlyUpdate.type,
      payload: payloadForm,
    });
    yield put({
      type: formReqLongTermUpdate.type,
      payload: formLongTerm,
    });
  } catch (error: any) {
    switch (error?.response?.data?.code) {
      case "NOT_FOUND":
        toast.error("Không tìm thấy đơn");
        break;
      case "ERR_01012":
        toast.error("Không có quyền truy cập");
        break;
      default:
        toast.error(error?.response?.data?.message ?? "Có lỗi xảy ra");
        break;
    }

    yield put({
      type: getEmployeeArriveLateDetailFailed.type,
      payload: ErrorMessage[error?.response?.data?.code] ?? "Có lỗi xảy ra",
    });
  }
}

function* watchGetEmployeeArriveLateDetail() {
  yield takeLatest(
    getEmployeeArriveLateDetailStart.type,
    getEmployeeArriveLateDetailWork
  );
}

export default function* getEmployeeArriveLateDetailSaga() {
  yield all([watchGetEmployeeArriveLateDetail()]);
}
